<template>
  <div>
    <button-options
      :access="access"
      :hideAdd="true"
      :hideDelete="false"
      :hideEdit="false"
      :hideDetail="false"
      :hideDuplicate="false"
      :viewTo="viewTo"
      @onDeleteClicked="onDeleteClicked"
      @onEditClicked="onEditClicked"
      @onDuplicateClicked="onDuplicateClicked"/>
  </div>
</template>

<script>
import ButtonOptions from '../directives/button-options';

export default {
  name: 'DeviceEdit',
  components: { ButtonOptions },
  props: ['access', 'device', 'viewTo'],
  data() {
    return {
      isSubmit: false,
    };
  },
  computed: {
    data() {
      return { ...this.device };
    },
  },
  methods: {
    onDeleteClicked() {
      this.$emit('onDeleteClicked', this.data);
    },
    onEditClicked() {
      this.$emit('onEditClicked', this.data);
    },
    onDuplicateClicked() {
      this.$emit('onDuplicateClicked', this.data);
    },
  },
};
</script>

<style scoped>

</style>
